<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="clamSize_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Clamp Size -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.CLAMP_SIZE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #clamSize_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.CLAMP_SIZE' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="clampSize"
        name="clampSize"
        class="input-select"
        [class.spinner]="loading"
        [class.select-disable]="enable"
        (selectionChange)="selectClampSize($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.clampId">{{ getClampNameSeries(x) }}</mat-option>
    </mat-select>
</div>
